const AMAZON_AFFILIATE_TAG = 'cratehacker0e-20';
const BEATPORT_AFFILIATE_ID = '69fa13d76195e';

const formatTerm = (value: string) =>
  value
    .replace(/\(.*?\)|\[.*?\]/g, '')
    .replace(/\b(feat|featuring)\b.*$/i, '')
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean)
    .join('+');

export function createAmazonAffiliateUrl(artist: string, song: string) {
  const query = [formatTerm(artist), formatTerm(song)]
    .filter(Boolean)
    .join('+');
  return `https://www.amazon.com/s?k=${query}&tag=${AMAZON_AFFILIATE_TAG}`;
}

export function createBeatportAffiliateUrl(artist: string, song: string) {
  const query = [formatTerm(artist), formatTerm(song)]
    .filter(Boolean)
    .join('+');
  return `https://www.beatport.com/search?q=${query}&a_aid=${BEATPORT_AFFILIATE_ID}`;
}

export function isBeatportUrl(url: unknown): boolean {
  if (typeof url !== 'string') return false;
  return /(^|\.)beatport\.com/i.test(url);
}
